var SystemUtil = (function () {
    function SystemUtil() {
    }
    return SystemUtil;
}());
export { SystemUtil };
SystemUtil.platform = "AwayJS";
